import { createFileRoute } from '@tanstack/react-router';
import { academicSeo } from '@/components/astro/pages/academic-landing-page';
import { FUNNEL_CAMPAIGN } from '@/components/funnel/config/funnels';
import { SqueezePage } from '@/components/funnel/squeeze/squeeze-page';
import { normalizeCanonicalUrl } from '@/seo/canonical';
import { seo } from '@/seo/seo';

/**
 * `/academic-2` — the squeeze-page academic ad landing page. Its CTAs enter
 * the onboarding funnel at `/onboarding/welcome` (`SqueezePage` navigates
 * there itself, and sends an already-signed-in visitor to the app instead).
 *
 * The `/academic-1` sibling pins the other landing+funnel pair. Neither reads
 * a flag: see the note on that route for why this URL stays out of
 * `experimental-routes.ts`.
 *
 * Shared-cacheable but NOT country-keyed, unlike `/academic-1`: nothing here
 * renders free-plan copy — the squeeze CTA label is a fixed message, and the
 * nav's auth chip and the CTA's signed-in branch both resolve client-side off
 * `authClient.useSession()`.
 *
 * Same `campaign` as the funnel's other entrances so the funnel's own events
 * stay one series; `$current_url` on the pageview is what separates this URL
 * from `/academic`.
 */
export const Route = createFileRoute('/_marketing/academic-2')({
  head: () => ({
    meta: [...seo(academicSeo)],
    links: [{ rel: 'canonical', href: normalizeCanonicalUrl('/academic') }],
  }),
  component: AcademicSqueezeRoute,
});

function AcademicSqueezeRoute() {
  return <SqueezePage campaign={FUNNEL_CAMPAIGN} />;
}
